import { render, staticRenderFns } from "./largeSource.vue?vue&type=template&id=30fc3f33&scoped=true"
import script from "./largeSource.vue?vue&type=script&lang=js"
export * from "./largeSource.vue?vue&type=script&lang=js"
import style0 from "./largeSource.vue?vue&type=style&index=0&id=30fc3f33&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc3f33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30fc3f33')) {
      api.createRecord('30fc3f33', component.options)
    } else {
      api.reload('30fc3f33', component.options)
    }
    module.hot.accept("./largeSource.vue?vue&type=template&id=30fc3f33&scoped=true", function () {
      api.rerender('30fc3f33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeSource.vue"
export default component.exports